module.exports = __webpack_public_path__ + "img/banner6.1c27fc35.png";